import type { Meta, StoryFn } from '@storybook/react';

import { ParagraphDisplay } from '@pega/cosmos-react-core';
import type { ParagraphDisplayProps } from '@pega/cosmos-react-core';

export default {
  title: 'Core/Paragraph',
  component: ParagraphDisplay
} as Meta;

export const ParagraphDisplayDemo: StoryFn<ParagraphDisplayProps> = (
  args: ParagraphDisplayProps
) => {
  return <ParagraphDisplay value={args.value} />;
};

ParagraphDisplayDemo.args = {
  value: "Here's a string with\na new line in it."
};

ParagraphDisplayDemo.argTypes = {
  value: { control: { type: 'text', multiLine: true } }
};
